module.exports = __webpack_public_path__ + "band_12.dac94977.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_12.png
// module id = GROo
// module chunks = 0